import { render, staticRenderFns } from "./PreferredStorePopover.vue?vue&type=template&id=168f881a&scoped=true"
import script from "./PreferredStorePopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreferredStorePopover.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PreferredStorePopover.vue?vue&type=style&index=0&id=168f881a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168f881a",
  null
  
)

export default component.exports